import { Component } from '@angular/core';
import { FormBuilder, FormsModule, ReactiveFormsModule, Validators } from '@angular/forms';
import { Router, RouterModule } from '@angular/router';
import { AgritourismAuthService } from '../../../auth/auth.service';
import { AgritourismAlertService } from '../../../services/alert.service';

@Component({
  selector: 'curbnturf-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.scss'],
  standalone: true,
  imports: [FormsModule, ReactiveFormsModule, RouterModule],
})
export class AgritourismLoginComponent {
  loginForm = this.fb.group({
    email: this.fb.control<string>('', [Validators.required, Validators.email]),
    password: this.fb.control<string>('', Validators.required),
  });

  constructor(
    private alertService: AgritourismAlertService,
    private authService: AgritourismAuthService,
    private fb: FormBuilder,
    private router: Router,
  ) {}

  login() {
    if (this.loginForm.valid) {
      this.authService
        .login(this.loginForm.value.email || '', this.loginForm.value.password || '')
        .subscribe({
          next: () => this.router.navigate(['', 'auth', 'redirect']),
          error: (err) => this.alertService.alert('warning', `Error logging in: ${err.message}`, 'Login Failed'),
        });
    }
  }
}
